module.exports = __webpack_public_path__ + "img/f69dbe8.png";